<template>
  <v-container fluid>
    <v-layout align-center justify-center v-if="error">
        <v-flex xs12 sm6 md4 lg3 xl2>
            <v-card class="mb-4">
                <v-card-text>
                <p class="mb-0 red--text"><b>{{error.title}}:</b> {{error.message}}</p>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
    <v-layout v-if="showForm">
      <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
        <v-card>
          <v-container>
            <v-card-text>
              <div class="headline mb-4 text-center">Welcome to VNFBay</div>
              <p><b>{{inviteeName}}</b> has invited you to join <b>{{organisation}}</b> organisation at VNFBay. Please set a new password in order to access the account.</p>
              <v-form id="registration-form" ref="form" v-model="valid" lazy-validation>
                <v-text-field
                v-model="password"
                :rules="[rules.password]"
                label="New Password"
                prepend-icon="lock"
                type="password"
              ></v-text-field>
              <v-text-field
                v-model="passwordConfirmation"
                :error-messages='passwordMatchError()'
                label="Confirm Password"
                prepend-icon="lock"
                type="password"
              ></v-text-field>
                <p>Make sure to read our <a href="https://vnfbay.com/terms/" target="_blank">Terms </a> and <a href="https://vnfbay.com/privacy/" target="_blank">Privacy Policy</a></p>
                <v-checkbox
                  v-model="agreed"
                  :rules="[rules.agree]"
                  label="I agree to the Terms and Privacy Policy"
                  required
                ></v-checkbox>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="submit"
                  :disabled="loading"
                  :loading="loading"
                  form="registration-form"
                  >
                  submit
                </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="invitationComplete">
      <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
        <v-card>
          <v-card-text>
            <p class="mb-0 green--text"><b>Password updated.</b> You can now login with your new password.</p>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" color="primary" to="/login">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    invitationComplete: false,
    isValid: false,
    agreed: false,
    isHashValid: false,
    resetComplete: false,
    password: '',
    passwordConfirmation: '',
    hash: '',
    rules: {
      agree: v => !!v || 'You must agree to continue!',
      password: v => !!v || 'Password is required'
    },
    inviteeName: '',
    email: '',
    organisation: ''
  }),
  computed: {
    showForm () {
      return this.isHashValid && !this.invitationComplete
    },
    comparePasswords () {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : true
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    this.hash = this.$route.params.hash
    this.$store.dispatch('validateInvitationHash', { hash: this.hash }).then(resp => {
      this.isHashValid = true
      this.inviteeName = resp.data.invitee
      this.organisation = resp.data.organisation
      this.email = resp.data.email
    }).catch((error) => {
      console.log(error)
      this.isHashValid = false
    })
  },
  methods: {
    passwordMatchError () {
      return (this.password === this.passwordConfirmation) ? '' : 'Passwords don\'t match'
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('acceptInvitation', {
          hash: this.hash,
          password: this.password
        }).then(() => {
          this.invitationComplete = true
        })
      }
    }
  }
}
</script>
